import { useEffect, useState } from 'react';

// Helper to format duration display
const formatDuration = (duration) => {
  if (duration === 1) return '1 Month';
  if (duration === 3) return '3 Months';
  return `${duration} Months`;
};

function PricingSection({ selectedValue, selectedPlanName, onChangePlan }) {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    fetch('/plans.json')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to load plans data');
        }
        return res.json();
      })
      .then((data) => {
        if (isMounted) {
          const mappedPlans = Array.isArray(data)
            ? data.map((plan) => ({
                ...plan,
                value: plan.duration, // duration is now the value directly
                durationDisplay: formatDuration(plan.duration),
              }))
            : [];
          setPlans(mappedPlans);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (isMounted) {
          setError(err.message || 'Something went wrong');
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const planName = "Premium Online Training";

  return (
    <section className="pricing" id="plans">
      <div className="pricing-header">
        <h2>
          Simple, Transparent <span className="accent">Pricing</span>
        </h2>
        {planName && <p className="plan-name-display">{planName}</p>}
        <p>Choose the plan that fits your training needs</p>
      </div>
      {loading && <p style={{ textAlign: 'center' }}>Loading plans...</p>}
      {error && !loading && <p style={{ textAlign: 'center', color: '#b91c1c' }}>{error}</p>}
      {!loading && !error && (
        <div className="pricing-grid">
          {plans.map((plan) => (
            <article
              key={`${plan.name}-${plan.duration}`}
              role="button"
              tabIndex={0}
              aria-pressed={selectedValue === plan.value}
              onClick={() => onChangePlan(plan.value, plan.name, plan.duration)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onChangePlan(plan.value, plan.name, plan.duration);
                }
              }}
              className={`plan-card ${selectedValue === plan.value ? 'highlighted' : ''}`}
            >
              {selectedValue === plan.value && <div className="ribbon">Selected</div>}
              <h3>{plan.durationDisplay}</h3>
              {plan.freeze_period && (
                <p className="plan-subtext">{plan.freeze_period}</p>
              )}
              <div className="plan-features-section">
                <h4 className="plan-features-title">Features:</h4>
                <ul className="plan-features">
                  {plan.features?.map((item, idx) => (
                    <li key={`${item}-${idx}`}>
                      <span className="check-icon">✔</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                {plan.additional_benefits && plan.additional_benefits.length > 0 && (
                  <>
                    <h4 className="plan-features-title">Additional Benefits:</h4>
                    <ul className="plan-features">
                      {plan.additional_benefits.map((item, idx) => (
                        <li key={`${item}-${idx}`}>
                          <span className="check-icon">✔</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}

export default PricingSection;


